import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import { apiError } from '../lib/host';
import AuthShell from '../components/AuthShell';
import './Auth.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await authAPI.forgotPassword(email);
      setSent(res.data.message);
    } catch (err) {
      setError(apiError(err, 'Could not send the reset link. Please try again.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <h2>Forgot password</h2>
      {sent ? (
        <>
          <div className="success-message">{sent}</div>
          <p className="tcx-hint">
            The link works once and expires in 30 minutes. Check your spam folder if it doesn't arrive.
          </p>
        </>
      ) : (
        <>
          <p className="tcx-hint" style={{ marginBottom: 16 }}>
            Enter your account email and we'll send you a link to set a new password.
          </p>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={submit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" value={email} required disabled={loading} autoComplete="email"
                onChange={(e) => { setEmail(e.target.value); setError(''); }} />
            </div>
            <button className="submit-btn" disabled={loading}>{loading ? 'Sending...' : 'Send reset link'}</button>
          </form>
        </>
      )}
      <p className="auth-link"><Link to="/login">Back to login</Link></p>
    </AuthShell>
  );
}
